/** * @usage: * *
<CheckBox label="Foo" value="foo" v-model="MySelectedValues" />
*
<CheckBox label="Bar" value="bar" v-model="MySelectedValues" />
*
<CheckBox label="Baz" value="baz" v-model="MySelectedValues" />
* * data(){ * return { * MySelectedValues: [], * } * } */

<template>
    <label class="ap-checkbox by-value" :class="['theme-' + theme, disabled ? 'disabled' : '']">
        <input class="checkbox" type="checkbox" :checked="isChecked" :value="value" @input="updateInput" :disabled="disabled" />
        <i class="ap-checkmark ap-icon ap-icon-check" :class="{ checked: isChecked }"></i>
        <span class="space" v-if="label || $slots.default"></span>
        <slot>{{ label }}</slot>
    </label>
</template>

<script>
    export default {
        model: {
            prop: 'modelValue',
            event: 'change',
        },
        props: {
            value: { type: [String, Number, Boolean], default: true },
            modelValue: { default: '' },
            label: { type: String, required: false },
            trueValue: { default: true },
            falseValue: { default: false },
            disabled: { default: false },
            theme: { type: String, default: 'green' },
        },
        computed: {
            isChecked() {
                if (this.modelValue instanceof Array) {
                    return this.modelValue.includes(this.value);
                }
                // Note that `true-value` and `false-value` are camelCase in the JS
                return this.modelValue === this.trueValue;
            },
        },
        methods: {
            updateInput(event) {
                let isChecked = event.target.checked;

                if (this.modelValue instanceof Array) {
                    let newValue = [...this.modelValue];

                    if (isChecked) {
                        newValue.push(this.value);
                    } else {
                        newValue.splice(newValue.indexOf(this.value), 1);
                    }

                    this.emutUpdate(newValue);
                } else {
                    this.emutUpdate(isChecked ? this.trueValue : this.falseValue);
                }
            },
            emutUpdate(newValue) {
                this.$emit('change', newValue);
                this.$emit('update:modelValue', newValue);
            },
        },
    };
</script>

<style lang="scss" scoped>
    /* Customize the label (the wrapper) */
    .ap-checkbox {
        margin: 0;
        display: inline-flex;
        align-items: center;
        position: relative;
        cursor: pointer;
        @include mixins.noselect;

        .space {
            margin: 5px;
        }

        /* Hide the browser's default checkbox */
        input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
            height: 0;
            width: 0;
        }

        /* Create a custom checkbox */
        .ap-checkmark {
            @include mixins.rounded;
            background-color: #ffffff;
            color: #ffffff;
            border: 1px solid rgba(31, 65, 115, 0.6);
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            font-size: 11px;
        }
        &.sm .ap-checkmark {
            width: 18px;
            height: 18px;
            font-size: 7px;
        }

        /* When the checkbox is checked, add a background */
        &.by-checked {
            input:checked ~ .ap-checkmark {
                background-color: variables.$color-green;
                border-color: variables.$color-green;
            }
            input:not(:checked) ~ .ap-checkmark:before {
                color: transparent;
            }
        }
        &.by-value.theme-green .ap-checkmark {
            color: transparent;
            &.checked {
                background-color: variables.$color-green;
                border-color: variables.$color-green;
                color: #ffffff;
            }
        }
        &.by-value.theme-outline .ap-checkmark {
            color: transparent;
            &.checked {
                border-color: variables.$color-primary;
                color: variables.$color-primary;
            }
        }

        &:disabled,
        &.disabled {
            cursor: unset;
            .ap-checkmark {
                border-color: variables.$color-disabled;
                color: variables.$color-on-disabled;
                background-color: variables.$color-disabled;
            }
        }
    }
</style>
